import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { orderedSteps } from './steps';
import classNames from 'classnames';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  progress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    gap: theme.marginBase / 2,
  },
  progressFill: {
    flex: 1,
    height: 5,
    backgroundColor: theme.colors.blue,
  },
  progressEmpty: {
    flex: 1,
    height: 5,
    backgroundColor: theme.colors.blueMuted,
  },
}));

interface Props {
  currStep: number;
  className?: string;
}

const NUMBER_OF_STEPS: number = orderedSteps.length;

export const OnboardingProgressBar = ({ currStep, className }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      aria-label={`${currStep} / ${NUMBER_OF_STEPS}`}
      role="progressbar"
      className={classNames(classes.progress, className)}
    >
      {new Array(NUMBER_OF_STEPS).fill(0).map((_, index) => (
        <div
          key={index}
          className={
            index <= currStep ? classes.progressFill : classes.progressEmpty
          }
        />
      ))}
    </div>
  );
};
